//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CategoriesGrid'
}
